interface ProgressCircleProps {
    value: number
    max?: number
    size?: number
    strokeWidth?: number
    color: string
  }
  
  export function ProgressCircle({
    value,
    max = 10,
    size = 64,
    strokeWidth = 4,
    color
  }: ProgressCircleProps) {
    const radius = (size - strokeWidth) / 2
    const circumference = radius * 2 * Math.PI
    const offset = circumference - (value / max) * circumference
  
    return (
      <div className="relative" style={{ width: size, height: size }}>
        <svg
          className="-rotate-90"
          style={{ width: size, height: size }}
        >
          <circle
            className="stroke-[#e0e0e0]"
            strokeWidth={strokeWidth}
            fill="none"
            r={radius}
            cx={size / 2}
            cy={size / 2}
          />
          <circle
            className="transition-all duration-500 ease-out"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            fill="none"
            r={radius}
            cx={size / 2}
            cy={size / 2}
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-xl font-medium">{value.toFixed(1)}</span>
        </div>
      </div>
    )
  }
  
  